import * as ActionTypes from './layout.actionTypes';

const initialState = {
  breakpoint: 'desktop',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.BREAKPOINT_CHANGE: {
      const breakpoint = action.payload;
      return {
        ...state,
        breakpoint,
      };
    }
    default:
      return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/modules/layout/layout.reducer.js